import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import QueriesTable from "./QueriesTable";

const QueriesTab = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const { rfqId } = useParams();
  const [queries, setQueries] = useState();
  const [activeTab, setActiveTab] = useState("PENDING");
  const [tab, setTab] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const getQueries = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/query?rfqId=${rfqId}&status=${activeTab}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setQueries(res.data);
      setIsLoading(false);
      localStorage.removeItem("tab");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getQueries();
  }, [activeTab]);

  const tabButtons =
    storedUser.userRole[0] === "BUYER"
      ? [
          { label: "Pending", value: "PENDING", tab: 1 },
          { label: "Answered", value: "ANSWERED", tab: 2 },
          { label: "Rejected", value: "REJECTED", tab: 3 },
        ]
      : null;
  return (
    <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
      <Typography variant="h4">Queries</Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
          borderBottom: "1px solid #D1D1D1",
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          {tabButtons.map((btn) => (
            <Button
              key={btn.value}
              className={`dashboard-btns ${
                activeTab === btn.value ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab(btn.value);
                setTab(btn.tab);
                setIsLoading(true);
              }}
            >
              {btn.label}
            </Button>
          ))}
        </Box>
      </Box>

      <QueriesTable
        queries={queries}
        isLoading={isLoading}
        getQueries={getQueries}
        tab={tab}
      />
    </Box>
  );
};

export default QueriesTab;
